import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.25rem;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const TotalWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-block-start: 0.25rem;
  border-block-start: 1px solid var(--t-horizontal-vertical-rule);
`;

export default {
  Wrapper,
  InfoWrapper,
  TotalWrapper,
};
